import { createSelector } from 'reselect';
import { List as ImmutableList } from 'immutable';
import { sortWatchList } from 'data/spendingWatchList/utils';
import { REDUCER_KEY } from './reducer';

export const getSpendingWatchListStore = (state) => state[REDUCER_KEY];

export const getIsLoading = (state: any) => getSpendingWatchListStore(state).isLoading;
export const getLoadPending = (state: any) => getSpendingWatchListStore(state).loadPending;
export const getLastSyncDate = (state: any) => getSpendingWatchListStore(state).lastSyncDate;

export const getSpendingWatchLists = (state) => getSpendingWatchListStore(state).resourcesById;

export const getSpendingWatchListData = createSelector(
  (state) => getSpendingWatchLists(state),
  (spendingWatchLists) => {
    let data = new ImmutableList();
    if (!spendingWatchLists) {
      return data;
    }
    let index = 0;
    spendingWatchLists.forEach((swl) => {
      data = data.push({
        id: swl.id,
        filterId: swl.filterId,
        name: swl.name,
        thisMonth: swl.thisMonth,
        yearToDate: swl.yearToDate,
        monthlyTrend: swl.monthlyTrend,
        numMonthlyTrendMonths: swl.numMonthlyTrendMonths,
        monthSpendingProjection: swl.monthSpendingProjection,
        targetAmount: swl.targetAmount,
        emoji: swl.emoji,
        createdAt: swl.createdAt,
        order: index,
      });
      index+=1;
    });
    return data;
  }
);

export const getSortedWatchlists = createSelector(
  (state) => getSpendingWatchListData(state),
  (state, sortOrder) => sortOrder,
  (spendingWatchLists, sortOrder) => sortWatchList(spendingWatchLists, sortOrder) || new ImmutableList()
);


export const getSpendingWatchListByName = (state, name) => {
  if (state.resourcesById) {
    return state.resourcesById.find((x) => x.name === name) || null;
  }
  return null;
};
